import React, { useEffect, useState } from "react";
import SearchBar from "../Main/searchBar";
import "./viewBooking.css";
import CustomRewardPointsPopup from "./customPopup";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getBookingsListById,
  addRewardPoints,
  cancelBooking,
} from "../../Redux/Actions/bookingActions";
import { ReactComponent as View } from "../../Global Icons/View Modal.svg";
import PriceDetailModal from "../../Global Functions/priceDetailModal";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
import UpdateLegalDocumentsPopup from "./legalDocument";
import { TailSpin } from "react-loader-spinner";
import toast from "react-hot-toast";

/* ── tiny helper: one label/value row ── */
const Row = ({ label, value }) => {
  const empty = value === undefined || value === null || value === "";
  return (
    <div className="vb-row">
      <span className="vb-row__key">{label}</span>
      <span className={`vb-row__val${empty ? " vb-row__val--muted" : ""}`}>
        {empty ? "—" : value}
      </span>
    </div>
  );
};

/* ── status badge ── */
const statusClass = (s = "") => {
  const v = s.toLowerCase();
  if (v === "confirmed") return "vb-badge--confirmed";
  if (v === "pending")   return "vb-badge--pending";
  if (v === "cancelled") return "vb-badge--cancelled";
  return "vb-badge--default";
};

const ViewBooking = () => {
  const { id } = useParams();

  const [pricePopup,        setPricePopup]        = useState(false);
  const [rewardPointsPopup, setRewardPointsPopup] = useState(false);
  const [confirmReward,     setConfirmReward]     = useState(false);
  const [pendingPoints,     setPendingPoints]     = useState(null);
  const [notePopup,         setNotePopup]         = useState(false);
  const [legalDocsPopup,    setLegalDocsPopup]    = useState(false);
  const [noteLoading,       setNoteLoading]       = useState(false);
  const [note,              setNote]              = useState("");

  const { admin }   = useSelector((state) => state.admin || {});
  const accessCode  = admin?.data?.access_code || [];
  const canAdd      = Array.isArray(accessCode) && accessCode.includes("add");
  const canEdit     = Array.isArray(accessCode) && accessCode.includes("edit");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => { dispatch(getBookingsListById(id)); }, [id, dispatch]);

  const { booking } = useSelector((state) => state.bookings || {});

  /* ── handlers (logic unchanged) ── */
  const legalDocsPopupHandler    = () => setLegalDocsPopup(!legalDocsPopup);
  const priceModalHandler        = () => setPricePopup(!pricePopup);
  const rewardPointsPopupHandler = () => setRewardPointsPopup(!rewardPointsPopup);

  const notePopupHandler = () => {
    setNotePopup(!notePopup);
    setNote("");
  };

  const handleNoteChange  = (e) => setNote(e.target.value);

  const handleNoteSubmit = () => {
    if (!note.trim()) { toast.error("Please enter a note"); return; }
    setNoteLoading(true);
    dispatch(cancelBooking({ booking_id: booking?.data?._id, note: note.trim() })).then((res) => {
      setNoteLoading(false);
      if (res && res.statusCode === 200) {
        toast.success("Note submitted successfully!");
        setNotePopup(false);
        dispatch(getBookingsListById(id));
      } else {
        toast.error("Failed to submit note. Please try again.");
      }
    });
  };

  const handleRewardPointsSubmit = (points) => {
    setPendingPoints(points);
    setConfirmReward(true);
  };

  const handleRewardPointsSubmitConfirmed = () => {
    if (pendingPoints !== null) {
      dispatch(addRewardPoints({
        user_id:       booking?.data?.user?._id,
        reward_points: Number(pendingPoints),
        booking_id:    booking?.data?._id,
      })).then((res) => {
        if (res && res.status === "success") {
          toast.success("Reward points assigned successfully!");
          setRewardPointsPopup(false);
          dispatch(getBookingsListById(id));
        } else {
          toast.error("Failed to assign reward points. Please try again.");
        }
        setConfirmReward(false);
        setPendingPoints(null);
      });
    }
  };

  const isCancelled   = booking?.data?.booking_status === "cancelled" ||
                        booking?.data?.booking_status === "confirmed";
  const canReward     = booking?.data?.booking_status === "confirmed" &&
                        booking?.data?.booking_from !== "kiosk";
  const bookingStatus = booking?.data?.booking_status || "";

  return (
    <div className="vb-root">

      <div className="header-top" style={{ marginLeft: "52%"}}>
          <SearchBar style={{ width: "max-content" }} />
        </div>

      {/* ════════════════════════════════════════
          Page Header
      ════════════════════════════════════════ */}
      <div className="vb-header">
        <div className="vb-header__left">
          {/* untouched: back button behaviour */}
          <button className="vb-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
            <BackIcon />
          </button>

          <div className="vb-header__sep" />

          <div className="vb-header__meta">
            <span className="vb-header__booking-id">
              {booking?.data?.booking_id || "—"}
            </span>
            <span className="vb-header__project-name">
              {booking?.data?.project?.project_name || "No project"}
            </span>
          </div>
        </div>

        <div className="vb-header__actions">
          {/* Legal Docs */}
          {canAdd && (
            <button className="vb-btn vb-btn--ghost" onClick={legalDocsPopupHandler}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
              Legal Documents
            </button>
          )}
          {/* Cancel Booking */}
          {canEdit && (
            <button
              className={`vb-btn ${isCancelled ? "vb-btn--disabled" : "vb-btn--danger"}`}
              onClick={isCancelled ? null : notePopupHandler}
              disabled={isCancelled}
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9"  y1="9" x2="15" y2="15"/>
              </svg>
              Cancel Booking
            </button>
          )}
        </div>
      </div>

      {/* ── Legal Docs Popup ── */}
      {legalDocsPopup && (
        <UpdateLegalDocumentsPopup
          bookingId={booking?.data?.booking_id}
          ID={booking?.data?._id}
          onClose={legalDocsPopupHandler}
          onUpdateSuccess={() => dispatch(getBookingsListById(id))}
        />
      )}

      {/* ════════════════════════════════════════
          Main Content Grid
      ════════════════════════════════════════ */}
      <div className="vb-grid">

        {/* ── Booking Overview ── */}
        <div className="vb-card vb-card--span2">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--blue" />
              Booking Overview
            </span>
            <div className={`vb-badge ${statusClass(bookingStatus)}`}>
              <span className="vb-badge__dot" />
              {ToFirstCapital(bookingStatus) || "Unknown"}
            </div>
          </div>

          <div className="vb-card__body vb-card__body--row">
            <div className="vb-overview__aside">
              <img
                className="vb-overview__img"
                src={booking?.data?.project?.project_type?.image || ""}
                alt="Project"
              />
            </div>
            <div className="vb-overview__fields">
              <Row label="Project ID"      value={booking?.data?.project?.project_id} />
              <Row label="Project Type"    value={booking?.data?.project?.project_type?.name} />
              <Row label="Project Name"    value={booking?.data?.project?.project_name} />
              <Row label="Booking Date"    value={DateToLocale(booking?.data?.created_at)} />
              <Row label="Booking Amount"  value={
                booking?.data?.booking_amount_currency && booking?.data?.booking_amount
                  ? `${booking.data.booking_amount_currency} ${Math.floor(booking.data.booking_amount * 100) / 100}`
                  : null
              } />
              <Row label="Booking From"    value={ToFirstCapital(booking?.data?.booking_from)} />
              <Row label="Payment Status"  value={ToFirstCapital(booking?.data?.payment_status)} />
              <Row label="Payment Method"  value={ToFirstCapital(booking?.data?.payment_method)} />
            </div>
          </div>
        </div>

        {/* ── Builder Info ── */}
        <div className="vb-card vb-card--builder">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--amber" />
              Builder
            </span>
          </div>
          <div className="vb-card__body">
            <Row label="Brand Name" value={booking?.data?.builder?.brand_name} />
            <Row label="Builder ID" value={booking?.data?.builder?.builder_id} />
          </div>
        </div>

        {/* ── Documents & Executive ── */}
        <div className="vb-card vb-card--docs">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--violet" />
              Documents &amp; Executive
            </span>
          </div>
          <div className="vb-card__body">
            <div className="vb-row">
              <span className="vb-row__key">Booking PDF</span>
              <a
                className="vb-link"
                href={booking?.data?.booking_pdf_url}
                download={`Booking-${booking?.data?.user?.name}`}
              >
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="7 10 12 15 17 10"/>
                  <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
                Download
              </a>
            </div>
            <Row label="Exec. Name"    value={booking?.data?.payment_executive?.name} />
            <Row label="Exec. Contact" value={booking?.data?.payment_executive?.contact_number} />
          </div>
        </div>

        {/* ── User Details ── */}
        <div className="vb-card vb-card--user vb-card--span2">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--blue" />
              User Details
            </span>
          </div>
          <div className="vb-card__body vb-card__body--row">
            <div className="vb-avatar-wrap">
              {booking?.data?.user?.profile_image ? (
                <img className="vb-avatar" src={booking.data.user.profile_image} alt="User" />
              ) : (
                <div className="vb-avatar vb-avatar--initials">
                  {(booking?.data?.user?.name || "?")[0].toUpperCase()}
                </div>
              )}
            </div>
            <div className="vb-user-fields">
              <Row label="Full Name"      value={booking?.data?.user?.name} />
              <Row label="User ID"        value={booking?.data?.user?.user_id || booking?.data?.user?._id} />
              <Row label="Email"          value={booking?.data?.user?.email} />
              <Row label="Contact"        value={
                booking?.data?.user?.country_code && booking?.data?.user?.contact_number
                  ? `${booking.data.user.country_code} ${booking.data.user.contact_number}`
                  : null
              } />
              <Row label="Reward Points"  value={booking?.data?.user?.reward_points || "0"} />
            </div>
          </div>
        </div>

        {/* ── Payment Details ── */}
        <div className="vb-card vb-card--payment vb-card--span2">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--green" />
              Payment Details
            </span>
          </div>
          <div className="vb-card__body vb-card__body--grid3">
            <Row label="Total Amount"       value={
              booking?.data?.total
                ? `${booking.data.currency || ""} ${Math.floor(booking.data.total * 100) / 100}`
                : null
            } />
            <Row label="Sub Total"          value={
              booking?.data?.sub_total
                ? `${booking.data.currency || ""} ${Math.floor(booking.data.sub_total * 100) / 100}`
                : null
            } />
            <Row label="Location Charges"   value={
              booking?.data?.preferred_location_charges !== undefined
                ? `${booking.data.currency || ""} ${Math.floor(booking.data.preferred_location_charges * 100) / 100}`
                : booking?.data?.properties?.[0]?.preferred_location_charges !== undefined
                  ? `${booking.data.currency || ""} ${Math.floor(booking.data.properties[0].preferred_location_charges * 100) / 100}`
                  : null
            } />
            <Row label="Additional Charges" value={
              booking?.data?.additional_charges
                ? `${booking.data.currency || ""} ${Math.floor(booking.data.additional_charges * 100) / 100}`
                : null
            } />
            <Row label="Coupon Discount"    value={
              booking?.data?.coupon_discount && booking.data.coupon_discount > 0
                ? `${booking.data.currency || ""} ${booking.data.coupon_discount}`
                : "No Coupon Applied"
            } />
            <Row label="Gift Card"          value={
              booking?.data?.gift_discount && booking.data.gift_discount > 0
                ? `${booking.data.currency || ""} ${booking.data.gift_discount}`
                : "No Gift Card Applied"
            } />
          </div>

          {canAdd && (
            <div style={{ padding: "0 24px 20px" }}>
              <button
                className={`vb-reward-btn ${canReward ? "" : "vb-reward-btn--off"}`}
                onClick={rewardPointsPopupHandler}
                disabled={!canReward}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
                Assign Reward Points
              </button>
              {rewardPointsPopup && (
                <CustomRewardPointsPopup
                  onClose={rewardPointsPopupHandler}
                  onSubmit={handleRewardPointsSubmit}
                />
              )}
            </div>
          )}
        </div>

        {/* ── Properties ── */}
        {Array.isArray(booking?.data?.properties) &&
          booking.data.properties.map((property) => (
            <div className="vb-card vb-card--property vb-card--span2" key={property._id}>
              <div className="vb-card__head">
                <span className="vb-card__title">
                  <span className="vb-card__dot vb-card__dot--sky" />
                  Property
                </span>
                <div className="vb-card__head-right">
                  <span style={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: "0.72rem",
                    color: "var(--vb-text-tertiary)",
                    letterSpacing: "0.04em",
                  }}>
                    #{property.property_id}
                  </span>
                  <div className={`vb-badge ${statusClass(property?.booking_status)}`}>
                    <span className="vb-badge__dot" />
                    {ToFirstCapital(property?.booking_status) || "—"}
                  </div>
                </div>
              </div>

              {/* Cover Photos */}
              {property?.cover_photos?.length > 0 && (
                <div className="vb-photos">
                  {property.cover_photos.map((photo) => (
                    <img
                      key={photo._id}
                      src={photo.url}
                      alt={`Cover ${photo.index + 1}`}
                      className="vb-photos__img"
                    />
                  ))}
                </div>
              )}

              {/* Property Fields */}
              <div className="vb-card__body vb-card__body--grid3">
                <Row label="Property Type"        value={ToFirstCapital(property?.property_type)} />
                <Row label="Construction Status"  value={property?.construction_status} />
                <Row label="Booked Properties"    value={booking?.data?.properties?.length} />
                <Row label="Possession Date"      value={property?.possession_date} />
                <Row label="Tower Name"           value={property?.tower_name || "No Tower"} />
                <Row label="Floor Number"         value={property?.floor !== undefined && property?.floor !== null ? property.floor : null} />
                <Row label="Unit Number"          value={property?.unitno} />
                <Row label="Unit Type"            value={property?.unit} />
                <Row label="Furnishing"           value={ToFirstCapital(property?.furnishing_status)} />
                <Row label="Transaction Currency" value={property?.currency} />
                <Row label="Completion Date"      value={new Date(property?.created_at).toLocaleString()} />
                <Row label="Project Type"         value={booking?.data?.project?.project_type?.name} />
                <Row label="Phases"               value={
                  booking?.data?.phases?.length
                    ? booking.data.phases.map((p) => p.name).join(", ")
                    : null
                } />
                <Row label="Address"              value={
                  booking?.data?.country?.country_name
                    ? `${booking?.data?.city?.city_name}, ${booking?.data?.state?.state_name}, ${booking?.data?.country?.country_name}`
                    : null
                } />
              </div>

              {/* Footer */}
              <div className="vb-prop-footer">
                <button className="vb-price-btn" onClick={priceModalHandler}>
                  <View />
                  Price Details
                </button>
                {pricePopup && (
                  <PriceDetailModal propertyData={property} onClick={priceModalHandler} />
                )}
                <button
                  className="vb-btn vb-btn--ghost"
                  onClick={() => navigate(`/manage_properties/view/${property?.property_id}`)}
                >
                  View Full Details
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="5" y1="12" x2="19" y2="12"/>
                    <polyline points="12 5 19 12 12 19"/>
                  </svg>
                </button>
              </div>
            </div>
          ))}
      </div>

      {/* ════════════════════════════════════════
          Cancel / Note Modal
      ════════════════════════════════════════ */}
      {notePopup && (
        <div className="vb-overlay">
          <div className="vb-modal">
            <div className="vb-modal__head">
              <span className="vb-modal__title">Cancellation Note</span>
              <button
                className="vb-modal__x"
                onClick={() => { setNotePopup(false); setNote(""); }}
                disabled={noteLoading}
              >✕</button>
            </div>

            <div className="vb-modal__body">
              <label className="vb-modal__field-label">Reason for cancellation</label>
              <textarea
                className="vb-modal__textarea"
                value={note}
                onChange={handleNoteChange}
                placeholder="Describe the reason for cancelling this booking…"
                disabled={noteLoading}
              />
            </div>

            <div className="vb-modal__foot">
              <button
                className="vb-btn vb-btn--secondary"
                onClick={() => { setNotePopup(false); setNote(""); }}
                disabled={noteLoading}
              >Discard</button>
              <button
                className="vb-btn vb-btn--primary"
                onClick={handleNoteSubmit}
                disabled={noteLoading}
              >
                {noteLoading
                  ? <TailSpin height="15" width="15" color="#fff" ariaLabel="loading" />
                  : "Submit Note"}
              </button>
            </div>

            {noteLoading && (
              <div className="vb-modal__loader">
                <TailSpin height="40" width="40" color="var(--vb-accent)" ariaLabel="loading" />
              </div>
            )}
          </div>
        </div>
      )}

      {/* ════════════════════════════════════════
          Confirm Reward Points Modal
      ════════════════════════════════════════ */}
      {confirmReward && (
        <div className="vb-overlay">
          <div className="vb-modal vb-modal--confirm">
            <div className="vb-modal__head">
              <span className="vb-modal__title">Confirm Reward Points</span>
              <button
                className="vb-modal__x"
                onClick={() => { setConfirmReward(false); setPendingPoints(null); }}
              >✕</button>
            </div>

            <div className="vb-modal__body">
              <div className="vb-confirm__icon">⭐</div>
              <p className="vb-confirm__text">
                Assign <strong>{pendingPoints}</strong> reward points to this user?
                This action cannot be undone.
              </p>
            </div>

            <div className="vb-modal__foot">
              <button
                className="vb-btn vb-btn--secondary"
                onClick={() => { setConfirmReward(false); setPendingPoints(null); }}
              >Cancel</button>
              <button
                className="vb-btn vb-btn--primary"
                onClick={handleRewardPointsSubmitConfirmed}
              >Confirm & Assign</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewBooking;